// extracted by mini-css-extract-plugin
module.exports = {"root":"R_bx","checked":"R_c0"};